import cookies from 'browser-cookies';


const HUBSPOT_COOKIE_NAME = "hubspotutk";
const HUBSPOT_ID = "543330"

/**
 * Submits a hubspot form for a new email address we have captured
 *
 * @param {String} email       Email Address
 * @param {String}  hubspot_form_id  The hubspot GUID for the form to submit for this contact.
 *
 */
export function submitHubspotLeadCaptureForm(email, hubspot_form_id) {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', 'https://api.hsforms.com/submissions/v3/integration/submit/' +HUBSPOT_ID + '/' + hubspot_form_id);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.onload = () => {};
  xhr.send(JSON.stringify({
    "submittedAt": +new Date(),
    "fields": [
      {
        "name": "email",
        "value": email
      }
    ],
    "context": {
      "hutk": cookies.get(HUBSPOT_COOKIE_NAME),
      "pageUri": document.location.href,
      "pageName": document.title,
    },
    "skipValidation": false
  }));
}

